
import css from 'styled-jsx/css';

export default css.global`/* @styled-jsx=global */

.content-download {
  &--padding {
    padding: 60px 0;
  }
  position: relative;

  label {
    padding-bottom: 5px;
  }
  #Instructsubscribecheckbox {
    display: none;
  }
}

.content-download__inner {
  max-width: 1290px;
  margin: 0 auto;
  position: relative;
  display: grid;
  grid-template-columns: repeat(14, 1fr);
  grid-column: 1 / span 14;
  gap: 20px 0;
  align-items: center;
}

.content-download__top {
  grid-column: 3 / 13;
  text-align: center;
  padding-bottom: 40px;

  @include media-query(tablet) {
    padding-bottom: 70px;
  }

  .subheader {
    display: block;
    margin-top: 20px;

    @include media-query(tablet) {
      display: none;
    }
  }
}

.content-download__left {
  grid-column: 2 / 14;
  position: relative;
  // padding: 10%;

  @include media-query(tablet) {
    grid-column: 2 / 8;
  }

  // @include media-query(desktop) {
  //   padding: 0;
  // }

  & > picture {
    text-align: center;

    img {
      max-width: 100%;
      max-height: 450px;
      width: auto;
    }
  }

  .magic-line-top,
  .magic-line-bottom {
    position: absolute;
    transform: scale(0.25); // 2x images

    @include media-query(desktop) {
      transform: scale(0.35);
    }

    @include media-query(mobile) {
      display: none;
    }
  }

  .magic-line-top {
    top: 0;
    right: 0;
    transform-origin: top right;

    @include media-query(tablet) {
      top: -60px;
      right: -50px;
    }

    @include media-query(desktop) {
      top: -60px;
      right: -20px;
    }
  }

  .magic-line-bottom {
    left: 0;
    bottom: 0;
    transform-origin: bottom left;

    @include media-query(tablet) {
      left: -50px;
      bottom: -60px;
    }

    @include media-query(desktop) {
      left: -20px;
      bottom: -60px;
    }
  }

  &.content-download__left--no-illustrations {
    padding-top: 0;
    padding-bottom: 0;
  }
}

.content-download__right {
  grid-column: 2 / 14;

  @include media-query(tablet) {
    grid-column: 9 / 14;
  }
}

.content-download__step-cta,
.content-download__step-confirmation {
  text-align: center;

  @include media-query(tablet) {
    text-align: left;
  }
}

.checklist {
  margin: 20px 0 20px;
  text-align: left;
}

.checklist__item {
  display: flex;
  margin: 10px 0;
}

.checklist__img {
  width: 18px;
  height: 18px;
  margin: 10px;
}

@include media-query(mobile) {
  .checklist__img {
    width: 14px;
    height: 14px;
    margin: 10px;
  }

  .checklist {
    margin: 20px 0;
    text-align: center;
  }
}

.checklist__text {
  padding: 5px 0;
  text-align: left;
}

.content-download__step-form {
  .form-container {
    padding-top: 20px;
  }

  .form {
    width: 100%;
    max-width: 100%;
    padding: 0;
    display: grid;
    gap: 0 10px;
    grid-template-areas:
      'first-name first-name'
      'last-name  last-name'
      'email      email'
      'company    company'
      'consent    consent'
      'submit     submit';

    @include media-query(desktop) {
      grid-template-areas:
        'first-name last-name'
        'email      email'
        'company    company'
        'consent    consent'
        'submit     submit';
    }

    @include media-query(mobile) {
      display: block;
    }

    .form-field:nth-of-type(1) {
      grid-area: first-name;
      display: flex;
      flex-direction: column;
    }

    .form-field:nth-of-type(2) {
      grid-area: last-name;
      display: flex;
      flex-direction: column;
    }

    .form-field:nth-of-type(3) {
      grid-area: email;
      display: flex;
      flex-direction: column;
      input[type='email'] {
        width: 100% !important;
      }
    }

    .form-field:nth-of-type(4) {
      grid-area: company;
      display: flex;
      flex-direction: column;
      input[type='text'] {
        width: 100% !important;
      }
    }

    // For some reason we don't render this field, despite it being in the
    // marketo schema
    .form-field:nth-of-type(5) {
      grid-area: job-title;
      display: none;
    }

    .form-field:nth-of-type(6) {
      grid-area: consent;
      justify-self: center;
      display: flex;
      flex-direction: row-reverse;
      justify-content: flex-end;

      input[type='checkbox'] {
        margin-right: 20px;
      }

      @include media-query(tablet) {
        justify-self: start;
      }
    }

    .submit-button {
      grid-area: submit;
      width: auto;
      justify-self: center;
      background-color: $blue !important;
      border: 2px solid $blue !important;
      color: $white;

      @include media-query(tablet) {
        justify-self: start;
      }
    }
  }
}

.content-download__step-cta {
  .subheader {
    display: none;
    @include media-query(tablet) {
      display: block;
    }
  }
}

.content-download__step-confirmation .cta {
  margin-top: 25px;
}
`